import { Navigate } from 'react-router-dom';

import { withLazyFallback } from 'lib/hoc/withLazyFallback';

import Medications from 'components/Patient/medications/Medications';

const HealthRecords = withLazyFallback(
  () => import('components/practice/charts/HealthRecords/HealthRecords')
);
const HealthRecordsHistories = withLazyFallback(
  () => import('components/practice/charts/HealthRecords/tabs/Histories/Histories')
);
const HealthRecordsAllergies = withLazyFallback(
  () => import('components/practice/charts/HealthRecords/tabs/Allergies/Allergies')
);
const HealthRecordsVaccines = withLazyFallback(
  () => import('components/practice/charts/HealthRecords/tabs/Vaccines/Vaccines')
);
const HealthRecordsVitals = withLazyFallback(
  () => import('components/practice/charts/HealthRecords/tabs/Vitals/Vitals')
);

const PRACTICE_CHARTS_HEALTH_RECORDS = [
  {
    path: 'health-records',
    element: <HealthRecords />,
    handle: { title: 'Health records' },
    children: [
      { path: 'histories', element: <HealthRecordsHistories />, handle: { title: 'Histories' } },
      { path: 'medications', element: <Medications />, handle: { title: 'Medications' } },
      { path: 'allergies', element: <HealthRecordsAllergies />, handle: { title: 'Allergies' } },
      { path: 'vaccines', element: <HealthRecordsVaccines />, handle: { title: 'Immunizations' } },
      { path: 'vitals', element: <HealthRecordsVitals />, handle: { title: 'Vitals' } }
    ]
  },
  // The chart's History section became Health records; keep old links (and bookmarks) working.
  // Medications was the only tab History ever had, so it is the one deep link worth carrying over.
  { path: 'history', element: <Navigate to="../health-records" replace /> },
  {
    path: 'history/medications',
    element: <Navigate to="../health-records/medications" replace />
  },
  { path: 'history/*', element: <Navigate to="../health-records" replace /> }
];

export default PRACTICE_CHARTS_HEALTH_RECORDS;
